import React from 'react';

type FieldConfigExclusionsSectionProps = {
    id?: string;
    exclusionType: 'hide' | 'disable';
    onExclusionChange: (type: 'hide' | 'disable') => void;
}

export const FieldConfigExclusionsSection: React.FC<FieldConfigExclusionsSectionProps> = ({
    id,
    exclusionType,
    onExclusionChange
}) => {
    const baseId = id || 'field-config-exclusions-section';

    return (
        <div id={baseId} data-testid={baseId} className="tw-mb-6">
            <div id={`${baseId}-label`} className="tw-text-grey-700 tw-text-sm tw-mb-2">Field exclusions</div>
            <div id={`${baseId}-options`} className="tw-flex tw-items-center tw-space-x-8">
                <label id={`${baseId}-hide-label`} className="tw-flex tw-items-center">
                    <input
                        id={`${baseId}-hide-radio`}
                        data-testid={`${baseId}-hide-radio`}
                        type="radio"
                        name="field-exclusion"
                        value="hide"
                        checked={exclusionType === 'hide'}
                        onChange={() => onExclusionChange('hide')}
                        className="tw-mr-2 tw-accent-[#091CAA]"
                    />
                    <span id={`${baseId}-hide-text`} className="tw-text-sm">Hide</span>
                </label>
                <label id={`${baseId}-disable-label`} className="tw-flex tw-items-center">
                    <input
                        id={`${baseId}-disable-radio`}
                        data-testid={`${baseId}-disable-radio`}
                        type="radio"
                        name="field-exclusion"
                        value="disable"
                        checked={exclusionType === 'disable'}
                        onChange={() => onExclusionChange('disable')}
                        className="tw-mr-2 tw-accent-[#091CAA]"
                    />
                    <span id={`${baseId}-disable-text`} className="tw-text-sm">Disable</span>
                </label>
            </div>
        </div>
    );
};
